import React, { useCallback, useEffect, useState } from "react";
import DadosProfissionaisItauForm from "./DadosProfissionaisItauForm";
import { useDispatch, useSelector } from "react-redux";
import {
  getPreenchimentoOperacao,
  isGravandoPreenchimentoOperacao,
} from "../../../../selectors/operacao.selectors";
import useCompleteForm from "../../../../hooks/useCompleteForm";
import validators from "../../../../utils/validators";
import { actions } from "../../../../actions/operacao.actions";
import { removeNonDigitsFromString } from "../../../../utils/basic";

const DadosProfissionaisItauFormConnected = ({
  handleGoTo3,
  events,
  comprador,
  setComprador,
  ...props
}) => {
  const dispatch = useDispatch();
  const {
    operacao,
    dominios: { perfilRenda: perfisRenda, profissao: profissoes },
  } = useSelector(getPreenchimentoOperacao);
  const submitting = useSelector(isGravandoPreenchimentoOperacao);

  const { tipo: tipoPerfilRenda } =
    perfisRenda.find((e) => e.id === comprador?.perfilRenda?.id) ?? {};
  const [exibeCnpj, setExibeCnpj] = useState(tipoPerfilRenda === "EM" ?? false);

  const callback = useCallback(
    (data) => {
      const c = data.operacao.participantes.find((p) => p.id === comprador.id);
      if (!!c) {
        setComprador({
          ...c,
          fluxo: data.validacao[
            data.operacao.detalhe.correntista ? "correntista" : "completa"
          ]?.participantes?.find((f) => f.id === c?.id)?.etapas,
        });
      }
      handleGoTo3();
    },
    [handleGoTo3, setComprador, comprador]
  );

  const resetValues = useCallback(
    () => ({
      renda: "",
      perfilRenda: null,
      ...comprador,
      dadosProfissionais: {
        cnpjEmpresa: "",
        profissao: null,
        ...comprador?.dadosProfissionais,
      },
    }),
    [comprador]
  );

  const [formProps, handleSubmit] = useCompleteForm({
    rules: () => ({
      renda: validators.number({ required: true }),
      perfilRenda: validators.object({ required: true }),
      dadosProfissionais: {
        profissao: validators.object({ required: true }),
        cnpjEmpresa: validators.cnpj({ required: exibeCnpj }),
      },
    }),
    initialValues: resetValues,
    handleSubmit: useCallback(
      (values) => {
        dispatch(
          actions.gravarPreenchimento.request({
            callback,
            instituicao: operacao.codigoInstituicao,
            passo: "dados-profissionais",
            participante: {
              id: comprador?.id,
              renda: values.renda,
              idPerfilRenda: values.perfilRenda?.id,
              dadosProfissionais: {
                idProfissao: values.dadosProfissionais.profissao?.id,
                cnpjEmpresa: !exibeCnpj
                  ? null
                  : removeNonDigitsFromString(
                      values.dadosProfissionais.cnpjEmpresa
                    ),
              },
            },
            operacao: {
              id: operacao.id,
            },
          })
        );
      },
      [callback, comprador, operacao, dispatch, exibeCnpj]
    ),
  });

  const handlePerfilRendaChange = useCallback(
    (v) => {
      setExibeCnpj(v?.tipo === "EM" ?? false);
    },
    [setExibeCnpj]
  );

  const { reset } = formProps;

  useEffect(() => {
    reset(resetValues());

    const { tipo: tipoPerfilRenda } =
      perfisRenda.find((e) => e.id === comprador?.perfilRenda?.id) ?? {};
    setExibeCnpj(tipoPerfilRenda === "EM" ?? false);
  }, [perfisRenda, comprador, resetValues, reset]);

  return (
    <DadosProfissionaisItauForm
      {...props}
      perfisRenda={perfisRenda}
      fluxo={comprador.fluxo}
      events={events}
      profissoes={profissoes}
      exibeCnpj={exibeCnpj}
      formProps={formProps}
      handlePerfilRendaChange={handlePerfilRendaChange}
      handleSubmit={handleSubmit}
      submitting={submitting}
    />
  );
};

export default DadosProfissionaisItauFormConnected;
